/**
 * mia-flow role model → UI capabilities. Mirrors the OPA role vocabulary in
 * .dev/access-control/policies-src/mia_flow/helpers/available_roles.rego.
 *
 * The FE uses these purely to shape the UI (hide/disable actions the caller cannot
 * perform); the gateway OPA policies remain the real enforcement point, so a stale or
 * bypassed check here can never grant real access. Fail-closed: no roles => read-only.
 *
 * Roles come from GET /api/bff/me/roles as a flat list of role-name URNs.
 */

export const MIA_FLOW_ROLE = {
  admin: 'urn:mia-platform-internal:role:mia-flow:admin',
  editor: 'urn:mia-platform-internal:role:mia-flow:editor',
  viewer: 'urn:mia-platform-internal:role:mia-flow:viewer',
}

/**
 * @param {Set<string>} roles - held mia-flow role URNs
 * @returns {{ isAdmin: boolean, isEditor: boolean, isViewerOnly: boolean, canWrite: () => boolean, roles: Set<string> }}
 */
export const capabilitiesFromRoles = (roles) => {
  const isAdmin = roles.has(MIA_FLOW_ROLE.admin)
  const isEditor = isAdmin || roles.has(MIA_FLOW_ROLE.editor)

  return {
    canWrite: () => isEditor,
    isAdmin,
    isEditor,
    isViewerOnly: !isEditor,
    roles,
  }
}
